<template>
  <div id="sgz-form-wrapper">
    <container style="max-width: 1080px">
      <grid vertical="middle" :rwd="{ compact: 'stack', tablet: 'stack' }">
        <grid-item
          size="1/2"
          :rwd="{ tablet: '1/1' }"
          id="survive"
          class="font-sarala hide-on-sm"
          style="line-height: 91px;letter-spacing: 7.64px;font-size: 73px;"
        >
          “Survive<br />
          no matter<br />
          the cost.”
        </grid-item>
        <grid-item size="1/2" :rwd="{ compact: '1/1', tablet: '1/1' }">
          <sgz-button style="width: 100%;font-size: 1.5em" />
          <div id="requirements">
            <requirements />
          </div>
        </grid-item>
      </grid>
    </container>
  </div>
</template>

<script>
import SgzButton from "./Button";
import Requirements from "./Requirements";

export default {
  name: "SgzForm",
  components: {
    SgzButton,
    Requirements
  }
};
</script>

<style lang="scss" scoped>
#sgz-form-wrapper {
  background-color: #000;
  padding-top: 5em;
  padding-bottom: 2em;
}

#requirements {
  margin-top: 2em;
}

#survive {
  font-size: 74px;
  font-weight: 700;
  letter-spacing: 7.75px;
  line-height: 93px;
}
</style>
